import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { ShowToastrService, Utilities, LocalStoreManager, GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { Invoice } from "src/app/frontoffice/order/model/invoice.model";
import { ReceiptPaymentModel, ReceiptPaymentTypeEnum } from "src/app/frontoffice/order/model/receiptpayment.model";
import { DialogType } from "../../../../../../projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { SettlementInvoiceModel } from "../../model/settlementinvoice.model";
import { SettlementReadInvoiceEnum, SettlementReadInvoiceModel } from "../../model/settlementreadinvoice.model";
import { SettlementReferenceModel } from "../../model/settlementreference.model";
import { CashierSettlementModel, SettlementDateViewModel } from "../../model/usersettlement.model";
import { InvoicesModalComponent } from "../invoicesmodal/invoicesmodal.component";
import { SimpleMenuComponent } from "./settlementsettingmenu";
import { ContextMenuEnum } from "src/app/frontoffice/order/model/contextMenuenum";
import { SettlementFormSettingModel } from "./settlementformsetting/settlementformsetting.model";
import { CashierLookupItems } from "../../model/cashierlookupitems.model";

@Component({
  selector: "cashiersettlement-form.component",
  templateUrl: "./cashiersettlement-form.component.html",
  styleUrls: ["./cashiersettlement-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CashierSettlementFormComponent extends BaseFormComponent<CashierSettlementModel> implements OnDestroy {
  userLookup: CashierLookupItems[];
  menu = SimpleMenuComponent;
  public contextmenuEnum: typeof ContextMenuEnum = ContextMenuEnum;
  PaymentMethod: Lookup[];
  deactivateSave: boolean;
  deactiveForm: boolean;
  RowState: typeof RowState = RowState;
  SettlementEnum: typeof SettlementReadInvoiceEnum = SettlementReadInvoiceEnum;
  invoice: Invoice[];
  showDetail: boolean;
  showDescription: boolean;
  deactivateClose: boolean;
  AddSettlementForPending: boolean;
  isSavedFinish: boolean;
  PersonnelReceiptReceived: number;
  formsetting: SettlementFormSettingModel;
  constructor(
    sts: ShowToastrService,
    private datatransfer: Datatransfer,
    private storage: LocalStoreManager,
    __id: FormContainerModel,
    private _tabsservice: TabularService,
    protected cd: ChangeDetectorRef,
    protected selectorService: SelectorService,
    public splashFormService: SplashFormService
  ) {
    super(selectorService, cd);
    this.currentrow = this.datatransfer?.currentrow;
    this.apiName = "CashierSettlemet";
    this.label = this.datatransfer?.label;
    this.areaName = this.datatransfer?.areaName;
    this._id = __id;
    this.tabsservice = _tabsservice;
    this.FillData();
  }
  async ngOnInit() {
    super.ngOnInit();
    this.FillData();
    this.setdefault();
  }
  ngOnDestroy(): void {}
  addControl() {
    this.setValue("ClearedInvoicesTotal", this.model.ClearedInvoicesTotal);
    this.setValue("PendingInvoicesTotal", this.model.PendingInvoicesTotal);
    this.setValue("PassiveInvoicesTotal", this.model.PassiveInvoicesTotal);
    this.setValue("DeletedInvoicesTotal", this.model.DeletedInvoicesTotal);
    this.setValue("CancelledInvoicesTotal", this.model.CancelledInvoicesTotal);
    this.setValue("CustomerClearedInvoicesTotal", this.model.CustomerClearedInvoicesTotal);
    this.setValue("PersonnelClearedInvoicesTotal", this.model.PersonnelClearedInvoicesTotal);
    this.setValue("PersonnelReceiptPaymentPaid", this.model.PersonnelReceiptPaymentPaid);
    this.setValue("Description", this.model.Description, false);
    this.setValue("UntilDate", this.model.UntilDate);
    this.setValue("UntilTime", this.model.UntilTime);
    this.setValue(
      "SettledPersonnelId",
      this.userLookup?.find((f) => f.PersonnelId === this.model.SettledPersonnelId)
    );
    this.setValue("PayableTotal", this.model.PayableTotal);
    this.setValue("Credit", this.model.InvoiceCredit);
    this.setValue("Tip", this.model.TipTotal);
    this.setValue("TotalDeposit", this.model.TotalDeposit);
    this.setValue("Discount", this.model.InvoicesDiscount);
    this.setValue("Debit", this.model.InvoiceDebit);
    this.setValue("Remain", this.model.Remain);
    this.setValue("OldRemain", this.model.OldRemain);
    this.setValue("TotalPayment", this.model.TotalPayment);
    this.setValue("AllowedDeficit", this.model.AllowedDeficit);
    this.setValue("TotalAccount", this.model.TotalAccount);
    this.setValue("CashierSpentCost", this.model.CashierSpentCost);
    this.setValue("PaymentLink", this.model.PaymentLink);

    if (this.model.ReceiptPayments && this.model.ReceiptPayments.length > 0) {
      this.model.ReceiptPayments.forEach((receipt, i) => {
        if (receipt.ReceiptPaymentTypeTitle) {
          this.setValue("ReceiptPaymentTypeTitle" + i, receipt.ReceiptPaymentTypeTitle);
        }
        if (receipt.PaymentMethodTitle) {
          this.setValue("PaymentMethodTitle" + i, receipt.PaymentMethodTitle);
        }
        if (receipt.Amount) {
          this.setValue("Amount" + i, receipt.Amount);
        }

        this.cd.markForCheck();
      });
    }
  }
  getCurrentDate() {
    this.httpCommonService
      .getList("DriverSettlement/GetCurrentDate")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: SettlementDateViewModel) => {
        this.setValue("UntilDate", data.UntilDate);
        this.setValue("UntilTime", data.UntilTime);
        this.cd.markForCheck();
      });
  }
  FillData() {
    if (this.accountService.authService?.currentBranch?.AddSettlementForUnpaidAndSuspendedInvoices) this.AddSettlementForPending = true;
    this.deactivateSave = true;
    if (this.model.Id) this.deactiveForm = true;
    this.getCurrentDate();
    this.getUserLookup();
    // گرفتن نوع پرداخت
    this.getPaymentMethod();

    if (!this.model.FiscalYearId && this.accountService.authService.currentFiscalYear) {
      this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    } else if (!this.model.FiscalYearId) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe(async (x) => {
        if (x) {
          this.model.FiscalYearId = x.Id;
          this.setValue("FiscalYearId", x.Id);
        }
      });
    }
  }
  setdefault() {}
  getUserLookup() {
    this.httpCommonService
      .getList("Personnel/ReadUserLookupItems/false")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: CashierLookupItems[]) => {
        this.userLookup = data;
        this.setValue(
          "SettledPersonnelId",
          this.userLookup.find((f) => f.PersonnelId === this.model.SettledPersonnelId)
        );
        if (this.userLookup && this.userLookup.length === 1) {
          this.setValue("SettledPersonnelId", this.userLookup[0]);
        }
      });
  }
  getPaymentMethod() {
    this.httpCommonService
      .getList("PaymentMethod/PaymentMethodLookUp" + "/" + this.accountService.authService.currentBranchId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: Lookup[]) => {
        if (data) {
          this.PaymentMethod = data;
        }
      });
  }
  // برای بایند کردن نام در سند html
  controlName(name: string, index: number): string {
    return name + index;
  }
  changeUser() {}
  /// دریافت اطلاعات کاربر انتخاب شده
  reciveInformation() {
    this.showDetail = false;
    this.deactivateSave = true;
    this.setdefault();
    if (!this.formGroup.controls["SettledPersonnelId"].value) {
      this.sts.showToast("danger", "", `${this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.CashierIsNotLoggedIn")}`);
      return;
    }
    if (!this.formGroup.controls["UntilDate"].value || !this.formGroup.controls["UntilTime"].value) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.EnterDateAndTimeFilter")}`,
        this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.Attention")
      );
      return;
    }
    this.splashFormService.openDialog();
    this.model.SettledUserlId = this.formGroup.value.SettledPersonnelId.Id;
    this.model.SettledPersonnelId = this.formGroup.value.SettledPersonnelId.PersonnelId;
    this.model.UntilDate = this.formGroup.value.UntilDate;
    this.model.UntilTime = this.formGroup.value.UntilTime;
    this.model.BranchId = this.accountService.authService.currentBranchId;

    this.httpCommonService
      .create("CashierSettlemet/CashierSettlemet", this.model)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: CashierSettlementModel) => {
          if (data.PassiveInvoicesTotal > 0) {
            this.splashFormService.closeLoading();
            this.sts.showDialog(
              `${this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.UndecidedInvoicesSettledBeforeSettlementCashier")}`,
              ""
            );
            if (this.AddSettlementForPending) this.deactivateSave = true;
            this.checkValidation();
          }
          this.model = data;
          this.showDetail = true;
          this.deactivateSave = false;
          this.addControl();
          this.addGroup();
          this.splashFormService.closeLoading();
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(
            `${Utilities.getHttpResponseMessage(error)}`,
            this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.Attention")
          );
        }
      );
  }
  openInvoicesModal(invoicekind: number) {
    let ReadInvoiceModel = new SettlementReadInvoiceModel();
    ReadInvoiceModel.UntilDate = this.formGroup.value.UntilDate;
    ReadInvoiceModel.Status = invoicekind;
    ReadInvoiceModel.SettledUserlId = this.formGroup.value.SettledPersonnelId.Id;
    ReadInvoiceModel.UntilTime = this.formGroup.value.UntilTime;
    let defaultFilters: GridFilter[] = [];
    switch (invoicekind) {
      case SettlementReadInvoiceEnum.Cleard:
        ReadInvoiceModel.InvoiceIds = this.model.ClearedInvoiceIds;
        break;
      case SettlementReadInvoiceEnum.Pending:
        ReadInvoiceModel.InvoiceIds = this.model.PendingInvoiceIds;
        break;
      case SettlementReadInvoiceEnum.Cancelled:
        ReadInvoiceModel.InvoiceIds = this.model.CancelledInvoiceIds;
        break;
      case SettlementReadInvoiceEnum.Passive:
        ReadInvoiceModel.InvoiceIds = this.model.PassiveInvoiceIds;
        break;
      case SettlementReadInvoiceEnum.Deleted:
        ReadInvoiceModel.InvoiceIds = this.model.DeletedInvoiceIds;
        break;
      case SettlementReadInvoiceEnum.Customer:
        ReadInvoiceModel.InvoiceIds = this.model.CustomerClearedIds;
        break;
      case SettlementReadInvoiceEnum.Personnel:
        ReadInvoiceModel.InvoiceIds = this.model.PersonnelClearedIds;
        break;
      case SettlementReadInvoiceEnum.PaymentPersonnel:
        defaultFilters = [{ Filed: "ReceiptPaymentTypeCode", Value: ReceiptPaymentTypeEnum.Payment, Skip: 0, Take: 0, Operator: "eq", Type: "F" }];
        ReadInvoiceModel.InvoiceIds = this.model.PersonnelClearedIds;
        break;
      case SettlementReadInvoiceEnum.Delivery:
        ReadInvoiceModel.InvoiceIds = null;
        break;
      case SettlementReadInvoiceEnum.Debit:
        ReadInvoiceModel.InvoiceIds = this.model.DebitInvoiceIds;
        break;
      case SettlementReadInvoiceEnum.Credit:
        ReadInvoiceModel.InvoiceIds = this.model.CreditInvoiceIds;
        break;
      case SettlementReadInvoiceEnum.Discount:
        ReadInvoiceModel.InvoiceIds = this.model.DiscountInvoiceIds;
        break;
      case SettlementReadInvoiceEnum.CostSpent:
        ReadInvoiceModel.InvoiceIds = this.model.CostSpentIds;
        break;
      case SettlementReadInvoiceEnum.PaymentLink:
        ReadInvoiceModel.InvoiceIds = this.model.PaymentLinkIds;
        break;
    }
    if (!ReadInvoiceModel.InvoiceIds || ReadInvoiceModel.InvoiceIds.length === 0) return;
    this.dialogService
      .open(InvoicesModalComponent, { ReadInvoiceModel: ReadInvoiceModel, defaultFilters }, { closeOnClickOutside: false })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {}),
      500;
  }
  removePayment(index: number) {
    const findIndex = this.model.ReceiptPayments.findIndex((f) => f.Index === index);
    this.model.ReceiptPayments.splice(findIndex, 1);
    this.formGroup.removeControl(`PaymentMethodId${index}`);
    this.formGroup.removeControl(`receivedmoney${index}`);
    this.calculate();
  }
  calculate() {
    this.model.TotalReciptPayment = 0;
    this.model.AllowedDeficit = 0;
    for (let index = 0; index < this.model.ReceiptPayments?.length; index++) {
      if (this.formGroup.controls[`receivedmoney${this.model.ReceiptPayments[index].Index}`]?.value) {
        this.model.TotalReciptPayment += Number(this.formGroup.controls[`receivedmoney${this.model.ReceiptPayments[index].Index}`].value);
      }
    }
    this.model.AllowedDeficit = Number(this.formGroup.controls[`AllowedDeficit`].value);
    this.model.Remain = this.model.TotalPayment - (this.model.TotalReciptPayment ? this.model.TotalReciptPayment : 0) - this.model.AllowedDeficit;
    this.formGroup.controls[`Remain`].setValue(this.model.Remain);

    this.checkValidation();
    this.cd.markForCheck();
  }
  //اضافه کردن به فرم گروپ
  addGroup() {
    if (!this.model.ReceiptPayments || this.model.ReceiptPayments.length <= 0) {
      const ReceiptModel = new ReceiptPaymentModel();
      const index = Math.floor(Math.random() * 10000000);
      ReceiptModel.PaymentMethod = JSON.parse(JSON.stringify(this.PaymentMethod));
      ReceiptModel.Index = index;
      if (!this.model.ReceiptPayments) this.model.ReceiptPayments = [];
      this.model.ReceiptPayments.push(ReceiptModel);
      this.setValue(`PaymentMethodId${index}`, this.PaymentMethod[0].Id, true);
      this.setValue(`receivedmoney${index}`, this.model.TotalPayment, true);
    } else {
      if (this.model.ReceiptPayments && this.model.ReceiptPayments.length > 0 && !this.formGroup) {
        for (let i = 0; i < this.model.ReceiptPayments.length; i++) {
          const index = Math.floor(Math.random() * 10000000);
          this.model.ReceiptPayments[i].Index = index;
          this.setValue(`PaymentMethodId${index}`, this.model.ReceiptPayments[i].PaymentMethodId, true);
          this.setValue(`receivedmoney${index}`, this.model.ReceiptPayments[i].Amount, true);
          if (this.model.ReceiptPayments[i].PaymentMethod.length === 1) this.setValue(`PaymentMethodId${index}`, this.PaymentMethod[0].Id, true);
        }
      } else {
        if (this.model.ReceiptPayments && this.model.ReceiptPayments.length > 0) {
          const index = this.model.ReceiptPayments.length - 1;
          const i = Math.floor(Math.random() * 10000000);
          this.setValue(`PaymentMethodId${i}`, this.model.ReceiptPayments[index].PaymentMethodId, true);
          this.setValue(`receivedmoney${i}`, this.model.ReceiptPayments[index].Amount, true);
          this.model.ReceiptPayments[index].State = RowState.New;
          this.model.ReceiptPayments[index].Index = i;
          if (this.model.ReceiptPayments[index].PaymentMethod.length === 1) this.setValue(`PaymentMethodId${i}`, this.PaymentMethod[0].Id, true);
          else {
            if (this.model.ReceiptPayments[index].PaymentMethodId) {
              this.setValue(`PaymentMethodId${i}`, this.model.ReceiptPayments[index].PaymentMethodId, true);
              this.setValue(`receivedmoney${i}`, this.model.ReceiptPayments[index].Amount, true);
            }
          }
        }
      }
    }
    this.checkValidation();
    this.calculate();
  }
  // فعال کردن دکنه تسویه
  checkValidation() {
    if (
      (this.formGroup?.valid &&
        this.formGroup.controls["TotalPayment"].value > 0 &&
        (this.model.PassiveInvoicesTotal === 0 ||
          !this.model.PassiveInvoicesTotal ||
          (this.model.PassiveInvoicesTotal > 0 && !this.AddSettlementForPending))) ||
      (this.formGroup?.valid &&
        this.formGroup.controls["Debit"].value > 0 &&
        (this.formGroup.controls["PayableTotal"].value === this.formGroup.controls["Debit"].value ||
          (this.formGroup.controls["PayableTotal"].value == 0 && this.formGroup.controls["Remain"].value == 0)))
    ) {
      this.deactivateSave = false;
    } else {
      this.deactivateSave = true;
    }
  }
  clear(value: any) {
    if (value === 0) {
      this.formGroup.controls[`receivedmoney`].setValue(0);
      this.calculate();
    }
    if (value === 1) {
      this.formGroup.controls[`AllowedDeficit`].setValue(0);
      this.calculate();
    }
  }
  addPayment() {
    const SettlementDetail = new ReceiptPaymentModel();
    const index = Math.floor(Math.random() * 10000000);
    SettlementDetail.PaymentMethod = JSON.parse(JSON.stringify(this.PaymentMethod));
    SettlementDetail.Index = index;
    this.model.ReceiptPayments.push(SettlementDetail);
    this.addGroup();
  }
  beforupdate() {}
  isValid(): boolean {
    if (this.model.PendingInvoicesTotal > 0 && this.AddSettlementForPending) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.TemporaryInvoicesSettledBeforeSettlementCashier")}`,
        "",
        DialogType.alert,
        () => {
          this.isSavedFinish = false;
          this.cd.markForCheck();
        }
      );
      return false;
    }
    return super.isValid();
  }
  async save() {
    if (!this.isValid()) {
      this.isSavedFinish = false;
      return;
    }
    this.splashFormService.openDialog();
    this.model.Invoices = [];
    this.model.Invoice = [];
    this.model.DeletedInvoiceIds?.forEach((element) => {
      const set = new SettlementInvoiceModel();
      set.InvoiceId = element;
      set.NotDisplay = true;
      this.model.Invoices.push(set);
    });
    this.model.ClearedInvoiceIds?.forEach((element) => {
      const set = new SettlementInvoiceModel();
      set.InvoiceId = element;
      this.model.Invoices.push(set);
    });
    this.model.PendingInvoiceIds?.forEach((element) => {
      const set = new SettlementInvoiceModel();
      set.InvoiceId = element;
      this.model.Invoices.push(set);
    });
    this.model.CancelledInvoiceIds?.forEach((element) => {
      const set = new SettlementInvoiceModel();
      set.InvoiceId = element;
      this.model.Invoices.push(set);
    });
    if (!this.model.SettlementReferences) this.model.SettlementReferences = [];
    this.model.PersonnelClearedIds?.forEach((element) => {
      const set = new SettlementReferenceModel();
      set.SettlementRefrenceId = element;
      this.model.SettlementReferences?.push(set);
    });
    this.model.CustomerClearedIds?.forEach((element) => {
      const set = new SettlementReferenceModel();
      set.SettlementRefrenceId = element;
      this.model.SettlementReferences?.push(set);
    });
    for (let index = 0; index < this.model.ReceiptPayments.length; index++) {
      this.model.ReceiptPayments[index].PaymentMethodId = this.formGroup.controls[`PaymentMethodId${this.model.ReceiptPayments[index].Index}`].value;
      this.model.ReceiptPayments[index].Amount = this.formGroup.controls[`receivedmoney${this.model.ReceiptPayments[index].Index}`].value;
      this.model.ReceiptPayments[index].BranchId = this.accountService.authService.currentBranchId;
      this.model.PayableTotal += this.model.ReceiptPayments[index].Amount;
    }

    this.sts.showToast("info", "", this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.SavingChanges"));
    this.isSaving = true;
    this.isSaved = false;
    this.model.PayableTotalPrice = this.model.PayableTotal;

    if (!this.model.FiscalYearId && this.accountService.authService.currentFiscalYear)
      this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    this.model.Description = this.formGroup.controls["Description"].value;
    this.model.CashierFirstNameTitle = this.userLookup?.find(
      (f) => f.PersonnelId === this.formGroup.controls["SettledPersonnelId"].value.PersonnelId
    )?.Title;
    this.model.CashierLastNameTitle = this.userLookup?.find(
      (f) => f.PersonnelId === this.formGroup.controls["SettledPersonnelId"].value.PersonnelId
    )?.Title;

    this.httpCommonService
      .create("CashierSettlemet", this.model)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: any) => {
          this.splashFormService.closeLoading();
          this.close();
        },
        (error) => {
          console.log(error);
          this.splashFormService.closeLoading();
        }
      );
    this.isClosing = false;
    this.submitted = true;
    this.sts.showToast(
      "success",
      this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.successful"),
      `${this.translate("ClientApp.FrontOffice.Financial.CashierSettlement.InformationChanges")}  ${this.label}  ${this.translate(
        "ClientApp.FrontOffice.Financial.CashierSettlement.SavedSuccessfully"
      )} `
    );
    this.result = true;
  }
  ngAfterViewInit(): void {
    this.FillData();
  }
}
